import i18next from "i18next";
import HTTP_STATUSES from "../../../../../general/constants/http/httpStatuses";

export enum ERRORS_BE {
	USER_BLOCKED = "USER_BLOCKED",
	ENTITY_NOT_FOUND = "ENTITY_NOT_FOUND",
	BAD_REQUEST = "Bad Request",
	ENTITY_ALREADY_EXIST = "ENTITY_ALREADY_EXIST",
	INCOMPATIBLE_FILE_EXT = "INCOMPATIBLE_FILE_EXT",
	INCOMPATIBLE_FILE_SIZE = "INCOMPATIBLE_FILE_SIZE",
	TRY_TO_DELETE_DATA_MANAGER = "TRY_TO_DELETE_DATA_MANAGER",
	TRY_TO_DELETE_DIV_MANAGER = "TRY_TO_DELETE_DIV_MANAGER",
}

const errorLocaleService = (e: any, status?: number) => {
	const t = i18next.t;
	if (status === HTTP_STATUSES.FORBIDDEN) {
		return t("err_text_12");
	}
	if (Array.isArray(e)) {
		return e;
	} else {
		switch (e) {
			case undefined:
				return t("err_text_1");
			case "Internal Server Error":
				return t("err_text_2");
			case "Forbidden resource":
				return t("err_text_3");
			case "Meeting not found":
				return t("err_text_5");
			case "Wrong email or password":
				return t("err_text_6");
			case "Internal server error":
				return t("err_text_7");
			case "User with this email already exists":
				return t("err_text_8");

			case ERRORS_BE.BAD_REQUEST:
				return t("err_text_11_1");
			case ERRORS_BE.USER_BLOCKED:
				return t("err_text_9");

			case ERRORS_BE.INCOMPATIBLE_FILE_SIZE:
				return t("text_93_9");

			case ERRORS_BE.INCOMPATIBLE_FILE_EXT:
				return t("text_93_10");

			case ERRORS_BE.ENTITY_ALREADY_EXIST:
				return t("text_m_195");

			case "USER_NOT_REGISTERED":
				return t("err_text_10");

			case "ENTITY_NOT_FOUND":
				return t("err_text_11");

			case "ACCESS_DENIED":
				return t("err_text_12");

			default:
				return t("err_text_4");
		}
	}
};

export default errorLocaleService;
